import * as React from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'

import Layout from '../../../../components/ui/Layout/Layout'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import { setGAPageView } from '../../../../services/analytics/google-analytics'
import { getAccessToken } from '../../../../services/data/accessToken'
import { setAccessToken } from '../../../../modules/auth/actions/creators'
import { screenSizes } from '../../../../services/generateMediaQueries'
import { doRequestOtp } from '../../../../controllers/DeleteAccount'

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  color: var(--color-secondary);
  font-weight: var(--font-weight-boldest);
`
const Description = styled.p`
  text-align: center;
`
const StyledList = styled.ul`
  margin-left: -20px;
  padding-bottom: 1.5rem;
`
const ButtonWrapper = styled.div`
  margin: 2rem 0 0;
`
const StyledButton = styled(ActionButton)`
  width: 100%;
`
const StyledLink = styled(ActionButton)`
  width: 100%;
  border: none;
  color: var(--color-primary);
  height: min-content;
`
const ErrorMessage = styled.p`
  color: var(--color-error);
  text-align: center;
`

function MainView(props) {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = React.useState(false)
  const [status, setStatus] = React.useState({})
  const {
    history,
    accessToken,
    location = {},
    setDeleteRequestId,
    setDeleteMaskedData,
    setDeleteOtpToMobile,
  } = props

  const checkToken = async () => {
    // redirect if no token found
    const cookieToken = await getAccessToken()
    if (!accessToken) {
      if (!cookieToken) {
        history.replace('/')
      } else {
        // save access token to store
        setAccessToken(cookieToken)
      }
    }
  }

  const handleContinue = async () => {
    setLoading(true)
    const isMobile = window.innerWidth <= screenSizes.small
    setDeleteOtpToMobile(isMobile)
    // call request otp
    const { status } = await doRequestOtp({
      setStatus,
      accessToken,
      toMobile: isMobile,
      setDeleteRequestId,
      setDeleteMaskedData,
    })

    // redirect to otp screen
    status === 200 && history.push('/delete-account/otp')
    setLoading(false)
  }

  const handleNotNow = () => {
    console.log('Account Deletion - Not Now')
    history.goBack()
  }

  React.useEffect(() => {
    checkToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  React.useEffect(() => {
    setGAPageView(location.pathname)
  }, [location.pathname])

  return (
    <Layout {...props}>
      <Title>Are you sure you want to delete your account?</Title>
      <Description>
        {`We're sorry to see you go. Before you proceed, here are a few important things to know:`}
      </Description>
      <StyledList>
        <li>
          Your account will be deleted immediately once you confirm your
          request.
        </li>
        <li>You will be automatically logged out of Zing.</li>
        <li>This action is permanent and cannot be undone.</li>
        <li>
          Once deleted, you will no longer be able to access your account and
          any associated features or services.
        </li>
      </StyledList>
      {status && status.error && <ErrorMessage>{status.error}</ErrorMessage>}
      <ButtonWrapper>
        <StyledButton type="submit" variant="primary" onClick={handleNotNow}>
          Not Now
        </StyledButton>
      </ButtonWrapper>
      <ButtonWrapper>
        <StyledLink type="button" onClick={handleContinue}>
          Continue
        </StyledLink>
      </ButtonWrapper>
    </Layout>
  )
}

MainView.defaultProps = {}

MainView.propTypes = {}

export default withRouter(MainView)
